const user = {
    state: {
       isPC:true,
       isPad:false,
       isFirst:true,
       currentWidth:1200,
       showOrientation:false
    },
    mutations: {
       setIsPC(state, value){
         state.isPC = value
       },
       setIsPad(state, value){
        state.isPad = value
      },
       setIsFirst(state, value){
        state.isFirst = value
      },
       setWidth(state, value){
         state.currentWidth = value
       },
      setShowOrientation(state, value){
        state.showOrientation = value
      }
    },
    actions: {
       setIsPC(context, value){
         context.commit('setIsPC', value)
       },
       setIsPad(context, value){
        context.commit('setIsPad', value)
      },
       setIsFirst(context, value){
        context.commit('setIsFirst', value)
      },
       setWidth(context, value){
         context.commit('setWidth', value)
       },
      setShowOrientation(context, value){
        context.commit('setShowOrientation', value)
      }
     
    }
}

export default user